module.exports = __webpack_public_path__ + "static/media/Australia.7d14e634.jpg";